"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../../Layout");

var _Hero = require("../Hero.style");

var HeroHeadlineImage = function HeroHeadlineImage(_ref) {
  var wrapperProps = _ref.wrapperProps,
      headlineImage = _ref.headlineImage;

  var mediaProps = _objectSpread(_objectSpread({}, headlineImage), {}, {
    mediaType: 'image'
  });

  return /*#__PURE__*/_react.default.createElement(_Hero.MediaWrapper, Object.assign({
    variant: "standard"
  }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.Overlay, null, /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroColumn, {
    width: 12,
    variant: "standard"
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeadlineImage, Object.assign({}, mediaProps, {
    variant: "standard"
  })))))));
};

HeroHeadlineImage.propTypes = {
  wrapperProps: _propTypes.default.shape({}),
  headlineImage: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  })
};
HeroHeadlineImage.defaultProps = {
  wrapperProps: null,
  headlineImage: null
};
var _default = HeroHeadlineImage;
exports.default = _default;